var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.374 5.374a.65.65 0 0 1 .919 0l7.224 7.223V5.833a.65.65 0 1 1 1.3 0v8.334a.65.65 0 0 1-.65.65H5.833a.65.65 0 1 1 0-1.3h6.764L5.374 6.293a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjM3MzcxIDUuMzczNzFDNS42Mjc1NSA1LjExOTg3IDYuMDM5MTEgNS4xMTk4NyA2LjI5Mjk1IDUuMzczNzFMMTMuNTE2NyAxMi41OTc0TDEzLjUxNjcgNS44MzMzM0MxMy41MTY3IDUuNDc0MzUgMTMuODA3NyA1LjE4MzMzIDE0LjE2NjcgNS4xODMzM0MxNC41MjU2IDUuMTgzMzMgMTQuODE2NyA1LjQ3NDM1IDE0LjgxNjcgNS44MzMzM0wxNC44MTY3IDE0LjE2NjdDMTQuODE2NyAxNC41MjU3IDE0LjUyNTYgMTQuODE2NyAxNC4xNjY3IDE0LjgxNjdMNS44MzMzMyAxNC44MTY3QzUuNDc0MzUgMTQuODE2NyA1LjE4MzMzIDE0LjUyNTcgNS4xODMzMyAxNC4xNjY3QzUuMTgzMzMgMTMuODA3NyA1LjQ3NDM1IDEzLjUxNjcgNS44MzMzMyAxMy41MTY3TDEyLjU5NzQgMTMuNTE2N0w1LjM3MzcxIDYuMjkyOTVDNS4xMTk4NyA2LjAzOTExIDUuMTE5ODcgNS42Mjc1NiA1LjM3MzcxIDUuMzczNzFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";